import { basePath } from 'api/kinerja/pengawas-sekolah/config'

import type {
  PelaksanaanPSListFilterState,
  PerencanaanFilterState,
} from 'types/kinerja-tim-penilai-ps'

export const apiPaths = {
  basePath,
  summary: (periodeId: string) =>
    `${basePath}/v1/pps/${periodeId}/evaluator/summary`,
  perencanaanListSummary: (periodeId: string) =>
    `${basePath}/v1/pps/perencanaan/${periodeId}/approval/filter`,
  perencanaanList: (periodeId: string, filter: PerencanaanFilterState) =>
    `${basePath}/v1/pps/perencanaan/${periodeId}/approval/skp-ps/${filter}`,
  perencanaanDetail: (id: string) =>
    `${basePath}/v1/pps/perencanaan/skp-ps/${id}`,
  approvalSend: `${basePath}/v1/pps/perencanaan/approval/kirim`,
  approvalRevision: `${basePath}/v1/pps/perencanaan/approval/arahkan-revisi`,
  approvalApprove: `${basePath}/v1/pps/perencanaan/approval/setujui`,
  pelaksanaan: `${basePath}/v1/pps/pelaksanaan`,
  pelaksanaanListSummary: (periodeId: string) =>
    `${basePath}/v1/pps/pelaksanaan/${periodeId}/penilaian/filter`,
  pelaksanaanList: (periodeId: string, filter: PelaksanaanPSListFilterState) =>
    `${basePath}/v1/pps/pelaksanaan/${periodeId}/penilaian/skp-ps/${filter}`,
  pelaksanaanSummary: (skpPsId) =>
    `${basePath}/v1/pps/pelaksanaan/penilaian/skp-ps/${skpPsId}/summary`,

  pelaksanaanPraktikKinerja: (skpPsId: string) =>
    `${apiPaths.pelaksanaan}/praktik-kinerja/skp-ps/${skpPsId}`,
  praktikKinerjaRatingRefleksi: (skpPsId: string) =>
    `${apiPaths.pelaksanaan}/praktik-kinerja/skp-ps/${skpPsId}/rating/refleksi-tindak-lanjut`,
  dokumenAkuntabilitas: (skpPsId: string) =>
    `${basePath}/v1/pps/pelaksanaan/dokumen-akuntabilitas/tk/skp-ps/${skpPsId}/dokumen-tersedia`,

  // Penilaian Periodik
  penilaianPeriodik: (periodeId: string) =>
    `${basePath}/v1/pps/penilaian/${periodeId}/periodik`,

  // Penetapan Predikat Kinerja
  penetapan: (periodeId: string) => `${basePath}/v1/pps/penetapan/${periodeId}`,
} as const

export const queryKeys = {
  API_GET_SUMMARY: 'penilai-ps-summary',
  API_GET_LIST_PERENCANAAN_PS: 'ps-pegawai-perencanaan-ps-list',
  API_GET_LIST_SUMMARY_PERENCANAAN_PS: 'ps-pegawai-perencanaan-ps-list-summary',
  API_GET_PERENCANAAN_PS_DETAIL: 'penilai-ps-perencanaan-approval-detail',
  API_GET_PELAKSANAAN_PERILAKU_KERJA_TK: 'pelaksanaan-ps-perilaku-kerja-tk',
  API_GET_PELAKSANAAN_PERILAKU_KERJA_TK_OPTIONS:
    'pelaksanaan-ps-perilaku-kerja-tk-options',

  API_GET_PELAKSANAAN_LIST_SUMMARY: 'penilai-ps-pelaksanaan-list-summary',
  API_GET_PELAKSANAAN_LIST: 'penilai-ps-pelaksanaan-list',
  API_GET_PELAKSANAAN_SUMMARY: 'penilai-ps-pelaksanaan-summary',
  API_GET_PELAKSANAAN_PRAKTIK_KINERJA_HASIL_SURVEY_KS:
    'penilai-ps-pelaksanaan-hasil-survey-ks',
  API_GET_DOKUMEN_AKUNTABILITAS: 'penilai-ps-pelaksanaan-dokumen-akuntabilitas',

  // Penilaian Periodik
  API_GET_PENILAIAN_PERIODIK: 'penilai-ps-penilaian-periodik',
  API_GET_PENILAIAN_PERIODIK_PEGAWAI: 'penilai-ps-penilaian-periodik-pegawai',
  API_GET_PENILAIAN_PERIODIK_PEGAWAI_DETAIL:
    'penilai-ps-penilaian-periodik-pegawai-detail',

  // Penetapan Predikat Kinerja
  API_GET_PENETAPAN_PEGAWAI: 'penilai-ps-penetapan-pegawai',
  API_GET_PENETAPAN_PEGAWAI_COUNT_STATUS:
    'penilai-ps-penetapan-pegawai-count-status',
  API_GET_PENETAPAN_PEGAWAI_COUNT_PREDICATE:
    'penilai-ps-penetapan-pegawai-count-predicate',
  API_GET_PENETAPAN_PEGAWAI_DETAIL: 'penilai-ps-penetapan-pegawai-detail',
}
